import { render, staticRenderFns } from "./credits-summary.vue?vue&type=template&id=0af71b76&"
import script from "./credits-summary.vue?vue&type=script&lang=js&"
export * from "./credits-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports